const SITE_URL = 'https://connecto-me.com';

const seoConfig = {
  '/': {
    ar: {
      title: 'كونكتو | منصة إدارة التجارة الإلكترونية علي أمازون ونون',
      description: 'أدر متاجرك على أمازون ونون وجوميا وترنديول من مكان واحد مع كونكتو. تابع المبيعات والمخزون والطلبات واستخدم أدوات ذكية لتنمية تجارتك',
      keywords: 'منصة إدارة التجارة الإلكترونية, Ecommerce Management Platform',
    },
    en: {
      title: 'Connecto | Ecommerce & Marketplace Management Platform',
      description: 'Manage Amazon, Noon, Jumia, and Trendyol stores from one platform. Track sales, inventory, and orders, and use AI-powered tools to grow your ecommerce business',
      keywords: 'Ecommerce Management Platform',
    },
  },
  '/about': {
    ar: {
      title: 'عن كونكتو | نبسط عمليات التجارة الإلكترونية',
      description: 'كونكتو تجمع بين أدوات المنصة الذكية وخدمة إدارة الحسابات، نساعد الشركات على إدارة وتنمية أعمالها علي أهم الأسواق في المنطقة من خلال نظام ذكي متكامل',
      keywords: 'عن كونكتو, About Connecto',
    },
    en: {
      title: 'About Connecto | We simplify e-commerce',
      description: "With Connecto, companies can manage and grow their businesses in the region's key markets through an integrated smart system.",
      keywords: 'About Connecto',
    },
  },
  '/about-platform': {
    ar: {
      title: 'منصة كونكتو | أدوات ذكية لإدارة وتنمية متجرك الإلكتروني',
      description: 'تعرف علي منصة كونكتو وأدواتها الذكية لإدارة حساباتك، إنشاء صور ومحتوى المنتجات، تحليل الأسعار والأرباح واتخاذ قرارات أفضل لنمو مبيعاتك',
      keywords: 'منصة كونكتو, أدوات ذكية لإدارة وتنمية متجرك الإلكتروني, AI Tools for Ecommerce Sellers',
    },
    en: {
      title: 'Connecto Platform | AI Tools for Ecommerce Sellers',
      description: "Discover Connecto's AI-powered ecommerce tools for marketplace management, product images, content, pricing, profit analysis, and smarter selling decisions.",
      keywords: 'AI Tools for Ecommerce Sellers',
    },
  },
  '/services': {
    ar: {
      title: 'إدارة حسابات البائعين علي منصات التجارة الإلكترونية',
      description: 'فريق كونكتو لإدارة حسابات البائعين، إدارة االمحتوي، الطلبات والشئون المالية، والمرتجعات، الحملات الإعلانية، وتنمية متجرك وزيادة المبيعات',
      keywords: 'إدارة حسابات البائعين علي منصات التجارة الإلكترونية, Ecommerce Seller Account management',
    },
    en: {
      title: 'Managing seller accounts on e-commerce platforms',
      description: "Connecto's team handles seller account management, content, orders and finances, returns, advertising campaigns, store growth, and sales increase.",
      keywords: 'Ecommerce Seller Account management',
    },
  },
  '/solutions': {
    ar: {
      title: 'إدارة حسابات البائعين علي منصات التجارة الإلكترونية',
      description: 'فريق كونكتو لإدارة حسابات البائعين، إدارة االمحتوي، الطلبات والشئون المالية، والمرتجعات، الحملات الإعلانية، وتنمية متجرك وزيادة المبيعات',
      keywords: 'إدارة حسابات البائعين علي منصات التجارة الإلكترونية, Ecommerce Seller Account management',
    },
    en: {
      title: 'Managing seller accounts on e-commerce platforms',
      description: "Connecto's team handles seller account management, content, orders and finances, returns, advertising campaigns, store growth, and sales increase.",
      keywords: 'Ecommerce Seller Account management',
    },
  },
  '/pricing': {
    ar: {
      title: 'باقات وأسعار منصة كونكتو | باقة مرنة ومخصصة',
      description: 'اختر باقة كونكتو المناسبة لتجارتك واستفد من أدوات إدارة وتحليل وتنمية متاجرك الإلكترونية على أمازون ونون وجوميا وترنديول',
      keywords: 'باقات وأسعار منصة كونكتو, Connecto Platform Pricing',
    },
    en: {
      title: 'Connecto Platform Prices | Flexible and Customized Package',
      description: 'Explore Connecto pricing plans and choose the right solution to manage, analyze, and grow your stores across Amazon, Noon, Jumia, and Trendyol.',
      keywords: 'Connecto Platform Pricing',
    },
  },
  '/supported-marketplaces': {
    ar: {
      title: 'ربط وتكامل مع نون | أمازون | جوميا | ترينديول',
      description: 'ربط وتكامل مع أكبر منصات التجارة الإلكترونية في المنطقة من خلال تكاملات API موثوقة وسريعة',
      keywords: 'ربط وتكامل مع نون أمازون جوميا ترينديول, Connected to Leading Marketplaces',
    },
    en: {
      title: 'Connected to Noon | Jumia | Amazon & Trendyol',
      description: 'Connected to Leading Marketplaces\nEasy and fast integration through an authorised API with the largest e-commerce platforms in the region',
      keywords: 'Connected to Leading Marketplaces',
    },
  },
  '/service/account-setup': {
    ar: {
      title: 'افتح حساب بائع على أمازون ونون وجوميا | كونكتو',
      description: 'يساعدك فريق كونكتو على تجهيز مستنداتك وفتح حساب بائع على أمازون ونون وجوميا وترينديول في مصر والسعودية والإمارات.',
      keywords: 'فتح حساب بائع, حساب بائع أمازون, حساب بائع نون, Account Setup, Seller Account Setup',
    },
    en: {
      title: 'Seller Account Setup for Amazon, Noon & More | Connecto',
      description: 'Connecto helps you prepare documents and set up seller accounts on Amazon, Noon, Jumia, and Trendyol across Egypt, Saudi Arabia, and the UAE.',
      keywords: 'Seller Account Setup, Amazon seller account, Noon seller account, ecommerce marketplace onboarding',
    },
  },
  '/partners': {
    ar: {
      title: 'تواصل مع فريق كونكتو | الدعم والمساعدة',
      description: 'تواصل مع فريق كونكتو للحصول على الدعم والمساعدة في استخدام المنصة وإدارة تجارتك وحساباتك على منصات التجارة الإلكترونية',
      keywords: 'تواصل مع فريق كونكتو, Contact Connecto',
    },
    en: {
      title: 'Contact Connecto | Ecommerce Platform Support',
      description: 'Contact the Connecto team for support with our platform tools and managing your business across multiple online marketplaces',
      keywords: 'Contact Connecto',
    },
  },
  '/support': {
    ar: {
      title: 'تواصل مع فريق كونكتو | الدعم والمساعدة',
      description: 'تواصل مع فريق كونكتو للحصول على الدعم والمساعدة في استخدام المنصة وإدارة تجارتك وحساباتك على منصات التجارة الإلكترونية',
      keywords: 'تواصل مع فريق كونكتو, Contact Connecto',
    },
    en: {
      title: 'Contact Connecto | Ecommerce Platform Support',
      description: 'Contact the Connecto team for support with our platform tools and managing your business across multiple online marketplaces',
      keywords: 'Contact Connecto',
    },
  },
  '/privacy': {
    ar: {
      title: 'سياسة الخصوصية | كونكتو',
      description: 'اقرأ سياسة خصوصية كونكتو. نحن ملتزمون بحماية بياناتك الشخصية وفقاً لأعلى المعايير العالمية.',
      keywords: 'سياسة الخصوصية, Privacy Policy',
    },
    en: {
      title: 'Privacy Policy | Connecto',
      description: 'Read Connecto\'s privacy policy. We are committed to protecting your personal data according to the highest global standards.',
      keywords: 'Privacy Policy',
    },
  },
  '/login': {
    ar: {
      title: 'تسجيل الدخول | كونكتو',
      description: 'سجل دخولك إلى منصة كونكتو لإدارة تجارتك الإلكترونية من لوحة تحكم واحدة.',
      keywords: 'تسجيل الدخول, Login',
    },
    en: {
      title: 'Login | Connecto',
      description: 'Log in to Connecto platform to manage your e-commerce from a single dashboard.',
      keywords: 'Login',
    },
  },
  '/register': {
    ar: {
      title: 'ابدأ تجربتك المجانية | كونكتو',
      description: 'سجل الآن وابدأ تجربتك المجانية مع كونكتو. أدر تجارتك على أمازون، نون، جوميا وترينديول.',
      keywords: 'ابدأ تجربتك المجانية, Start Your Free Trial',
    },
    en: {
      title: 'Start Your Free Trial | Connecto',
      description: 'Sign up now and start your free trial with Connecto. Manage your business on Amazon, Noon, Jumia, and Trendyol.',
      keywords: 'Start Your Free Trial',
    },
  },
  '/demo': {
    ar: {
      title: 'شاهد العرض التوضيحي | كونكتو',
      description: 'شاهد كيف تعمل منصة كونكتو وكيف يمكنها تبسيط إدارة تجارتك الإلكترونية.',
      keywords: 'العرض التوضيحي, Demo',
    },
    en: {
      title: 'Watch the Demo | Connecto',
      description: 'See how Connecto platform works and how it can simplify your e-commerce management.',
      keywords: 'Watch Demo',
    },
  },
};

// Aliases
seoConfig['/platform'] = seoConfig['/about-platform'];
seoConfig['/service/platform'] = seoConfig['/about-platform'];
seoConfig['/service/account-management'] = seoConfig['/services'];

export { SITE_URL };
export default seoConfig;
